module.exports = __webpack_public_path__ + "img/thumb_14.ab28a643.jpg";